import React, { useState } from 'react';
import { Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { API_OPERATIONS } from '../../shared/consts/api';
import './CallbackResend.css';

interface CallbackResendProps {
  businessId: string;
}

const CallbackResend: React.FC<CallbackResendProps> = ({ businessId }) => {
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');
  const [useAllBusinesses, setUseAllBusinesses] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{ success: boolean; message: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!dateStart || !dateEnd) {
      setResult({ success: false, message: 'Укажите даты начала и конца' });
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${API_OPERATIONS}correct/list/sendwebhook`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify({
          DateStart: new Date(dateStart).toISOString(),
          DateEnd: new Date(dateEnd).toISOString(),
          IDBusiness: useAllBusinesses ? '00000000-0000-0000-0000-000000000000' : businessId
        })
      });

      const data = await response.json();

      if (response.ok && data.data !== undefined) {
        setResult({
          success: true,
          message: `Успешно отправлено ${data.data} колбеков`
        });
      } else {
        setResult({
          success: false,
          message: data.message || 'Ошибка при отправке колбеков'
        });
      }
    } catch (error) {
      console.error('Error resending webhooks:', error);
      setResult({ success: false, message: 'Ошибка при отправке запроса' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="callback-resend-card">
      <Card.Header>
        <h5 className="mb-0">Переотправка колбеков</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <div className="callback-resend-row">
            <Form.Group className="callback-resend-field">
              <Form.Label>Дата начала</Form.Label>
              <Form.Control
                type="datetime-local"
                value={dateStart}
                onChange={(e) => setDateStart(e.target.value)}
                disabled={loading}
              />
            </Form.Group>

            <Form.Group className="callback-resend-field">
              <Form.Label>Дата конца</Form.Label>
              <Form.Control
                type="datetime-local"
                value={dateEnd}
                onChange={(e) => setDateEnd(e.target.value)}
                disabled={loading}
              />
            </Form.Group>
          </div>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="useAllBusinesses"
              label="Переотправить по всем мерчантам"
              checked={useAllBusinesses}
              onChange={(e) => setUseAllBusinesses(e.target.checked)}
              disabled={loading}
            />
          </Form.Group>

          {!useAllBusinesses && (
            <div className="callback-resend-info mb-3">
              ID мерчанта: <code>{businessId}</code>
            </div>
          )}

          <Button
            variant="primary"
            type="submit"
            disabled={loading}
            className="callback-resend-btn"
          >
            {loading ? (
              <>
                <Spinner size="sm" animation="border" className="me-2" />
                Отправка...
              </>
            ) : (
              'Переотправить колбеки'
            )}
          </Button>
        </Form>

        {result && (
          <Alert
            variant={result.success ? 'success' : 'danger'}
            className="mt-3 mb-0"
          >
            {result.message}
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
};

export default CallbackResend;
